import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  ExecuteSectionActionRequestObjectSchema,
  ExecuteSectionActionRequestObjectType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseExecuteSectionActionApiInterface {
  executeSectionActionApi: (
    input: ExecuteSectionActionRequestObjectType
  ) => Promise<any>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useExecuteSectionActionApi = (): UseExecuteSectionActionApiInterface => {
  const { nwApplicationService } = useNwApplicationService();

  const executeSectionAction = (
    requestObject: ExecuteSectionActionRequestObjectType
  ) => {
    try {
      ExecuteSectionActionRequestObjectSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return nwApplicationService.executeSectionAction(requestObject);
  };

  const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
    executeSectionAction,
    {
      mutationKey: ['executeSectionActionApi']
    }
  );

  return {
    executeSectionActionApi: mutateAsync,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    reset
  };
};

export { useExecuteSectionActionApi };
